import sdl from '@jds/react-generated-sdl/JDSTabsDesktop';
import type { JDSTabsDesktopProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, TabsProps } from '../logic';

const Component = (props: TabsProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    overflow = 'scroll',
    appearance = 'undefined',
    previousButtonAriaLabel = 'Previous Tab',
    nextButtonAriaLabel = 'Next Tab',
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      overflow,
      appearance,
      previousButtonAriaLabel,
      nextButtonAriaLabel,
      ...rest
    },
    'JDSTabsDesktop',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const Tabs = withLogic(Component) as React.FC<TabsProps> & {
  slotName?: string;
};

Tabs.displayName = 'Tabs';
Tabs.slotName = 'jds_tab';

export { Tabs, type JDSTabsDesktopProps };
